import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Button,
  Dialog,
  IconButton,
  Typography,
} from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";
import BoardLog from "./BoardLog";


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    width:'90%'
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  circularProgress: {
    margin: "0 auto",
    display: "block",
  },
  boardLog:{
    width:'90%'
  }
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const BoardLogPopup = withStyles(styles)(
  ({ boardLogOpen = false, setBoardLogOpen }) => {
    const handleClose = () => setBoardLogOpen(false);

    return (
      <Dialog
      className="boardLog"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title-board-log"
        open={boardLogOpen}
        fullWidth={true}
        maxWidth="md"
      >
        <DialogTitle id="customized-dialog-title-board-log" onClose={handleClose}>
          Board Log
        </DialogTitle>
        <DialogContent dividers>
         <BoardLog/>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

export default BoardLogPopup;
